function LPLegalShow() {
	const legal = document.querySelector('[data-lp-legal="data-lp-legal"]');
	if (legal) {
		const legalBtn = legal.querySelector('[data-lp-legal="data-lp-legal-btn"]'),
			legalText = legal.querySelector("#legal");

		legalBtn.addEventListener("click", function (event) {
			event.preventDefault();
			legal.classList.toggle("visible");
			legalBtn.classList.toggle("visible");

			if (legalBtn.classList.contains("visible")) {
				legalBtn.setAttribute("aria-expanded", "true");

				if (legalText) {
					legalText.setAttribute("tabindex", "0");
				}
			} else {
				legalBtn.setAttribute("aria-expanded", "false");
				legalText.setAttribute("tabindex", "");
			}
		});
	}
}

export default LPLegalShow;
